import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { getOrganizationViewUrl } from '../../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'
import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

// In the future, "variant" might be replaced by a combination of
// "documentType" & "action" if this proves to be a more scalable approach.
type InvoiceEditorVariantRoute = {
  variant: InvoiceEditorVariant
  getVariantRoute: (organizationUrl: string, documentId?: string) => string
}

const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice)
const quoteDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Quote)
const recurringInvoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.RecurringInvoice)

export const invoiceEditorVariantRoutes: InvoiceEditorVariantRoute[] = [
  {
    variant: InvoiceEditorVariant.InvoiceNew,
    getVariantRoute: (organizationUrl) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getNewDocumentRoute(invoiceDocumentRouteBase),
      ),
  },
  {
    variant: InvoiceEditorVariant.InvoiceDraftEdit,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getEditDocumentDraftRoute(invoiceDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.DepositInvoiceDraftEdit,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getEditDepositInvoiceDraftRoute(documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.FinalInvoiceDraftEdit,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getEditFinalInvoiceDraftRoute(documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.InvoiceDraftDuplicate,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getDuplicateDocumentDraftRoute(invoiceDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.InvoiceDuplicate,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getDuplicateDocumentRoute(invoiceDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.InvoiceNewFromQuote,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(organizationUrl, reactRoute.organization.invoices.getInvoiceFromQuoteRoute(documentId)),
  },
  {
    variant: InvoiceEditorVariant.DepositInvoiceNewFromQuote,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getDepositInvoiceFromQuoteRoute(documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.FinalInvoiceNewFromQuote,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getFinalInvoiceFromQuoteRoute(documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.CreditNoteFromInvoice,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getCreditNoteFromInvoiceRoute(documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.QuoteNew,
    getVariantRoute: (organizationUrl) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getNewDocumentRoute(quoteDocumentRouteBase),
      ),
  },
  {
    variant: InvoiceEditorVariant.QuoteDraftEdit,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getEditDocumentDraftRoute(quoteDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.QuoteDraftDuplicate,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getDuplicateDocumentDraftRoute(quoteDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.QuoteDuplicate,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getDuplicateDocumentRoute(quoteDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.QuoteEdit,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getEditDocumentRoute(quoteDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.RecurringInvoiceNew,
    getVariantRoute: (organizationUrl) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getNewDocumentRoute(recurringInvoiceDocumentRouteBase),
      ),
  },
  {
    variant: InvoiceEditorVariant.RecurringInvoiceDraftEdit,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getEditDocumentDraftRoute(recurringInvoiceDocumentRouteBase, documentId),
      ),
  },
  {
    variant: InvoiceEditorVariant.RecurringInvoiceDuplicate,
    getVariantRoute: (organizationUrl, documentId) =>
      getOrganizationViewUrl(
        organizationUrl,
        reactRoute.organization.invoices.getDuplicateDocumentRoute(recurringInvoiceDocumentRouteBase, documentId),
      ),
  },
]
